import React from 'react';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { StripeProvider } from './contexts/StripeContext.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import Routes from './Routes.jsx';
import './styles/tailwind.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <StripeProvider>
          <Routes />
        </StripeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;